import React, { useState } from 'react';
import { Phone } from 'lucide-react';
import ContactModal from './ContactModal';

const LpNavigation = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <nav className="bg-white shadow-md sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 sm:h-20">
            {/* Logo */}
            <a href="/lp" className="flex items-center shrink-0">
              <img src="/assets/img/brand/logo-dark.png" alt="Federal Trademark Experts" className="h-8 sm:h-10" />
            </a>

            {/* Right side - Phone + CTA Buttons */}
            <div className="flex items-center gap-2 sm:gap-4 md:gap-6">
              {/* Phone Number */}
              <a href="tel:+18444903064" className="hidden md:flex items-center gap-2 text-slate-700 hover:text-slate-900 transition-colors">
                <Phone className="h-4 w-4" />
                <span className="font-medium text-sm">+1 (844) 490-3064</span>
              </a>

              {/* Register My Trademark Button */}
              <button
                onClick={() => setIsModalOpen(true)}
                className="px-3 sm:px-5 py-2 sm:py-2.5 text-xs sm:text-sm font-semibold text-white rounded-full bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 shadow-lg hover:shadow-xl transition-all duration-300"
                data-testid="lp-register-btn"
              >
                Register Now
              </button>

              {/* Chat Now Button */}
              <button
                onClick={() => {
                  if (window.LiveChatWidget) {
                    window.LiveChatWidget.call('maximize');
                  }
                }}
                className="hidden sm:block px-5 py-2.5 text-sm font-semibold text-blue-600 border-2 border-blue-600 rounded-full hover:bg-blue-50 transition-all duration-300"
                data-testid="lp-chat-btn"
              >
                Chat Now
              </button>
            </div>
          </div>
        </div>
      </nav>

      <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default LpNavigation;
